import * as React from 'react';
import { css } from 'glamor';
import { Spin } from 'antd';

const spinnerClassName = css({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  margin: 'auto',
}).toString();

export default class LoadingOverlay extends React.Component {
  render() {
    return <Spin className={spinnerClassName} />;
  }
}
